var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSodaBeverageSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E49429"
    },
    d: "M394.817,202.888c-4.269-4.546-10.228-7.123-16.464-7.123H133.647 c-6.236,0-12.195,2.578-16.464,7.123c-4.269,4.545-6.469,10.65-6.081,16.873l16.941,271.059c0.744,11.906,10.616,21.18,22.545,21.18 h210.824c11.928,0,21.801-9.275,22.545-21.18l16.941-271.059C401.285,213.539,399.086,207.432,394.817,202.888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B77220"
    },
    d: "M394.817,202.888c-4.269-4.546-10.228-7.123-16.464-7.123H256V512h105.412 c11.928,0,21.801-9.275,22.545-21.18l16.941-271.059C401.285,213.539,399.086,207.432,394.817,202.888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C01E77"
    },
    d: "M256,150.588c-12.475,0-22.588-10.112-22.588-22.588V22.588C233.412,10.114,243.525,0,256,0h97.882 c12.475,0,22.588,10.114,22.588,22.588c0,12.476-10.113,22.588-22.588,22.588h-75.294V128 C278.588,140.476,268.475,150.588,256,150.588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7BD9BF"
    },
    d: "M361.412,512H150.588c-11.928,0-21.801-9.273-22.545-21.18l-22.588-361.412 c-0.389-6.224,1.812-12.33,6.081-16.873c4.269-4.545,10.228-7.123,16.464-7.123h256c6.236,0,12.195,2.578,16.464,7.123 c4.269,4.545,6.469,10.65,6.081,16.873L383.956,490.82C383.212,502.727,373.34,512,361.412,512z M171.809,466.824h168.382 l19.765-316.235H152.044L171.809,466.824z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2D6A8"
    },
    d: "M271.06,421.647c-5.945,0-11.768-2.412-15.973-6.617c-4.204-4.203-6.617-10.025-6.617-15.971 c0-5.947,2.412-11.768,6.617-15.973c4.204-4.206,10.026-6.615,15.973-6.615c5.945,0,11.765,2.409,15.97,6.615 c4.204,4.206,6.618,10.028,6.618,15.973c0,5.947-2.414,11.768-6.618,15.971C282.826,419.235,277.003,421.647,271.06,421.647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2D6A8"
    },
    d: "M240.941,331.293c-5.947,0-11.767-2.411-15.971-6.617c-4.204-4.201-6.615-10.025-6.615-15.971 c0-5.945,2.411-11.768,6.615-15.974c4.201-4.203,10.025-6.614,15.971-6.614s11.767,2.411,15.971,6.614 c4.204,4.206,6.617,10.029,6.617,15.974s-2.412,11.77-6.617,15.971C252.708,328.882,246.885,331.293,240.941,331.293z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#72C8B0"
    },
    d: "M400.464,112.535c-4.269-4.545-10.228-7.123-16.464-7.123H256v45.176h103.956l-19.765,316.235H256 V512h105.412c11.928,0,21.801-9.273,22.545-21.18l22.588-361.412C406.932,123.186,404.733,117.079,400.464,112.535z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSodaBeverageSvgrepoCom);
export default __webpack_public_path__ + "static/media/soda-beverage-svgrepo-com.65c06ed8f75fbcadb3474be439f0d4c7.svg";
export { ForwardRef as ReactComponent };